export const SET_CHAT_MODE = 'SET_CHAT_MODE'
export const SET_END_DOCUMENT_MODE = 'SET_END_DOCUMENT_MODE'
export const SET_DOCUMENT_MODE = 'SET_DOCUMENT_MODE'
export const SET_SHOW_FILE_VIEW = 'SET_SHOW_FILE_VIEW'

export function setChatMode(mode) {
  return {
    type: SET_CHAT_MODE,
    payload: mode
  }
}

export function setDocumentMode(documentMode) {
  return {
    type: SET_DOCUMENT_MODE,
    payload: documentMode
  }
}

export function setEndDocumentMode(hasEnded) {
  return {
    type: SET_END_DOCUMENT_MODE,
    payload: hasEnded
  }
}

export function setShowFileView(showFileView) {
  return {
    type: SET_SHOW_FILE_VIEW,
    payload: showFileView
  }
}
